import { useSearchParams } from 'react-router-dom'

// eslint-disable-next-line import/prefer-default-export
export const useGetValueFromUrlParam = <T>(key: string, defaultValue: T) => {
  const [searchParams] = useSearchParams()

  return (searchParams.get(key) ?? defaultValue) as T
}
